import './users-form.scss';
import { K_NODE_ACCOUNT_REQUEST } from '../users.controller';
import APIV5 from '~/models/api';
import templateModalUsersCreation from '~/pages/users/modal/modal-users-creation-duplicate.html';
import ModalUsersCreationDuplicateController from '~/pages/users/modal/modal-users-creation-duplicate.controller';

export default class UsersFormController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {import('~/scripts/services/form.service').default} FormService
	 */
	constructor(
		$location,
		$routeParams,
		$timeout,
		$uibModal,
		FormService,
	) {
		this.$location = $location;
		this.$routeParams = $routeParams;
		this.$uibModal = $uibModal;
		this.FormService = FormService;

		/** @type {any} */
		this.options = {
			displayBreadcrumb: false,
			displayKelse:      false,
			displayTabs:       false,
			mode:              'normal',
			new_isa:           null,
			parent:            null,
			readOnly:          false,
			tab:               'form',
			viewMode:          1,
		};

		this.kid = this.$routeParams.kid ?? K_NODE_ACCOUNT_REQUEST;
		this.create = !this.$routeParams.kid;
		this.submissions = {};
	}

	/**
	 * @param {Object<
	 *   import('@knitiv/api-client-javascript').KNode,
	 *   import('~/scripts/services/model/form').default
	 * >} forms
	 * @param {Object<string, {data: Object<string, any>}>} submissions
	 * @returns {Promise<void>}
	 */
	async checkDuplicates(forms, submissions) {
		const formKid = Object.keys(forms)[0];
		const links = [];

		for (const [k, m] of Object.entries(forms[formKid].map)) {
			const class_kid = m.path?.at(-1).kid;
			if (class_kid && [
				'K_NODE;FIRSTNAME',
				'K_NODE;LASTNAME',
				'K_NODE;EMAIL',
			].includes(class_kid)) {
				const values = submissions[formKid].data[k];
				if (Array.isArray(values)) {
					for (const value of values) {
						links.push({
							class_kid,
							value:         value.name,
							setValueError: false,
						});
					}
				}
				else {
					links.push({
						class_kid:     m.path.at(-1).kid,
						value:         values,
						setValueError: false,
					});
				}
			}
		}

		const resultPerson = await APIV5.instance.objectSearchWithLinks({
			class_kid: 'K_NODE;PERSON_SYS',
			links,
			onKSYSTEM: true,
		}, {
			id: 'users-new.handle-user',
		});
		if (resultPerson?.result.total >= 1) {
			const personKid = resultPerson.result.list[0].kid;
			const personKrepreIndex = submissions[formKid].data.KREPRE.findIndex(
				(/** @type {any} */ krepre) => krepre.lang.kid === 'K_NODE;PERSON_SYS',
			);
			const profilKrepreIndex = submissions[formKid].data.KREPRE.findIndex(
				(/** @type {any} */ krepre) => krepre.lang.kid === 'K_NODE;KPROFIL',
			);
			submissions[formKid].data.KREPRE[personKrepreIndex].value = personKid;

			const resultProfil = await APIV5.instance.objectSearchWithLinks({
				class_kid: 'K_NODE;KPROFIL',
				links: [{
					class_kid: 'K_NODE;PERSON_SYS',
					objnum2:   personKid,
				}],
				onKSYSTEM: true,
			}, {
				id: 'users-new.handle-user',
			});

			if (resultProfil?.result.total === 1) {
				submissions[formKid].data.KREPRE[profilKrepreIndex].value = resultProfil.result.list[0].kid;
			}
			else if (resultProfil?.result.total > 1) {
				/**
				 * @type {{
				 *   profil: import('@knitiv/api-client-javascript').KNode | '__create' | undefined
				 * }}
				 */
				const modalResult = await this.$uibModal.open({
					ariaLabelledBy:  'modal-users-creation-title',
					ariaDescribedBy: 'modal-users-creation-body',
					template:        templateModalUsersCreation,
					controller:      ModalUsersCreationDuplicateController,
					controllerAs:    '$ctrl',
					resolve:         {
						links: () => resultProfil.result.list,
					},
				}).result;

				if (modalResult?.profil !== '__create') {
					submissions[formKid].data.KREPRE[profilKrepreIndex].value = modalResult.profil;
				}
			}
		}
	}

	cancel() {
		this.$location.url('/users');
	}

	submit() {
		this.$location.url('/users');
	}
}
